// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"6e9649e6","397":"5a80f6c7"}[chunkId] + ".chunk.css";
};